<template>
<transition name="slideLeft">
<div class="container">
  <div class="card mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col-3">
              <avatar :username="user.displayName" :size="60" :backgroundColor="user.bgColor"></avatar>
            </div>
            <div class="col-9">
                <h5 class="mb-0">Welcome:</h5>
                <h3 class="mt-1">{{user.displayName}}</h3>
            </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button class="btn btn-sm btn-outline-primary" style="width:49%;">
            Total Workouts: {{totalWorkouts}}
          </button> 
          <button class="btn btn-sm btn-outline-info" style="width:49%;">
            This Month: {{monthWorkouts}}
          </button>
          </div>
        </div>
    </div><!-- .card-body--> 
  </div><!-- .card-->

  <ul class="list-group mt-2" v-if="!noWorkouts">
    <li class="list-group-item" v-for="workout in workouts" :key="workout.id" @click.prevent="goToWorkout(workout.id)">
      <icon v-if="workout.pr" class="text-warning" name="star"></icon>
      <span class="badge badge-pill" :class="[workout.workoutType == 'metcon' ? 'badge-primary' : workout.workoutType == 'lift' ? 'badge-secondary' :  'badge-info']">{{workout.workoutType}}</span> 
        {{format(workout.date, 'MM/DD/YYYY')}}
        <div v-if="workout.liftType" class="workoutDesc">Lift: {{workout.liftType}} - {{workout.description}}</div>
        <div v-else-if="workout.isNamedWod" class="workoutDesc">"{{workout.namedWod.name}}" - {{workout.namedWod.description}}</div>
        <div v-else class="workoutDesc">{{workout.description}}</div>
        <div class="workoutResult"><strong>Result:</strong> {{workout.result}} <span v-if="workout.rx" class="badge badge-pill badge-dark">Rx</span></div>
    </li>
  </ul>

  <div class="card" v-if="noWorkouts">
    <div class="card-body">
      <h4 class="card-title">Welcome to WhtBrd</h4>
      <p class="card-text">
        <h5>Get Started</h5>
        Just want a simple app to keep track of your workouts? You've come to the write place! 
        Add you first workout by clicking the big '+' below.
        <h5 class="mt-2">Update Your Profile</h5>
        Click on the Menu button (top left) then 'Profile' to change your avatar and add additional details to yuor account.
        <h2>Thank You!</h2>
    </div>
  </div>
  <button class="fabBtn" @click="goToNewWorkout"><icon name="plus"></icon></button>
</div>

</transition>
</template>

<script>
//import firebase from 'firebase'
import Avatar from 'vue-avatar'
import format from 'date-fns/format'

//import Workout from '@/workoutData.js'

export default {
  name: 'home',
  components: {
    Avatar
  },
  data () {
    return {
      displayMenu: false,
      msg: 'Welcome to WhtBrd',
      format: format,
      transitionName: ""
    }
  },
  computed: {
    badgeClass () {
      if (type = 'metcon') {
        return 'badge-primary'
      } else if (type = 'lift') {
        return 'badge-secondary'
      } else {
        return 'badge-light'
      }
    },
    allTimeScore () {
      return this.$store.getters.score
    },
    monthScore () {
      return this.$store.getters.scoreThisMonth
    },
    workouts () {
      return this.$store.state.workouts
    },
    authUser () {
      return this.$store.state.authUser
    },
    user () {
      return this.$store.state.user
    },
    totalWorkouts: function () {
      return this.$store.getters.totalWorkouts
    },
    monthWorkouts () {
      return this.$store.getters.workoutsThisMonth
    },
    noWorkouts: function () {
      return this.workouts.length == 0
    }
  },
  watch: {
    '$route': function(to, from) {
      //const toDepth = to.path.split('/').length
      const fromPath = from.path.split('/')
      console.log(fromPath)
      if(from.path = '/workout') {
        this.transitionName = slideLeft
      }
    }
  },
  created () {
    //this.$store.commit('setWorkouts')
  },
  methods: {
    goToWorkout: function (id) {
      //console.log(id)
      this.$router.push({ name: 'workout', params: { id: id }})
    },
    goToNewWorkout: function () {
       this.$router.push({ name: 'workout', params: { id: 0 }})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .fabBtn {
    position: fixed;
    right: 35px;
    bottom: 28px;
    z-index: 1001;
    background-color: #8E8C84;
    border-radius: 100%;
    width: 65px;
    height: 65px;
    line-height: 65px;
    color: #F8F5F0;
    text-align: center;
    transform: translate3d(0,0,0);
    transition: transform ease-out 200ms;
    box-shadow: 0px 2px 18px -5px rgba(0,0,0,0.3);
    
  }

  .list-group-item {
    border-radius: 0px
  }
  .list-group-item:first-child {
    border-top-left-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
    border-top-right-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
  }
 
 .list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
    border-bottom-left-radius: 255px 25px 225px 25px/25px 225px 25px 255px;
  }
  .badge-info {
    border: 1px solid black;
    background-color: #fff;
    color: #111;
  }
  .workoutDesc {
    max-height: 4.5em;
    overflow: hidden;
    position: relative;
    display: block;
    line-height: 1.5em;
    /*outline: solid 1px red;
    background-color: white;*/
  }
  .workoutDesc::before {
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, white 50%);
    content: '\200C';
    display: block;
    position: absolute;
    right: 0;
    top: 3em;
    width: 25%;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/home.vue